/**
 * Ponte Dashboard -> Registros de Pesca: o clique em "Sem local vinculado" abre
 * a lista já filtrada. Só projeto(s) e período viajam; qualquer outro filtro ativo
 * do Dashboard é sinalizado por `filtros_dashboard_ignorados` pra lista avisar.
 */

export type PendenciaRegistro = '' | 'sem_local' | 'nao_validados';

export const PARAM_FILTROS_IGNORADOS = 'filtros_dashboard_ignorados';

export interface FiltrosDashboardParaLista {
  uid_pesca_projetos: string[];
  dataInicio: string;
  dataFim: string;
  uid_pesca_especie: string | null;
  local: string | null;
  ambiente: string | null;
  uid_pesca_area: string | null;
  uid_pesca_pescador: string | null;
  uid_pesca_colonia: string | null;
  validacao: string;
  uid_pesca_local: string[];
  uid_pesca_apetrecho: string | null;
}

export function temOutrosFiltrosDashboard(f: FiltrosDashboardParaLista): boolean {
  return !!(
    f.uid_pesca_especie || f.local || f.ambiente || f.uid_pesca_area || f.uid_pesca_pescador ||
    f.uid_pesca_colonia || f.uid_pesca_apetrecho || f.validacao === 'somente_validados' || f.uid_pesca_local.length > 0
  );
}

export function montarUrlRegistrosSemLocal(f: FiltrosDashboardParaLista): string {
  const params = new URLSearchParams({ pendencia: 'sem_local' });
  if (f.uid_pesca_projetos.length) params.set('uid_pesca_projetos', f.uid_pesca_projetos.join(','));
  if (f.dataInicio && f.dataFim) {
    params.set('data_inicio_de', f.dataInicio);
    params.set('data_inicio_ate', f.dataFim);
  }
  if (temOutrosFiltrosDashboard(f)) params.set(PARAM_FILTROS_IGNORADOS, '1');
  return `/admin/registros?${params.toString()}`;
}

/** Sem local vinculado: texto informado + selo "sem vínculo", ou só "sem local" quando não há texto. */
export function descricaoSemLocal(registro: { descricao_local?: string | null }): { texto: string; selo: 'sem vínculo' | 'sem local' } {
  const texto = (registro.descricao_local || '').trim();
  return texto ? { texto, selo: 'sem vínculo' } : { texto: '', selo: 'sem local' };
}
